const renderCards = async () => {
  const response = await fetch(
    "https://rebuyengine.com/api/v1/custom/id/118129?shopify_product_ids=1943202267223&format=pretty&key=LeW7uHm9pGsCvh4t0%2FGXQKWvtQESCpLdLJUCetOoYacOIzbAFRt%2BYzpZ9ynJudvJy1r7YCzrSB5Qt1SlW1NEMA%3D%3D"
  );
  const parsedResponse = await response.json();
  const products = parsedResponse.data;

  products.forEach(async (product) => {
    const handle = product.handle;
    const response = await fetch(`/products/${handle}?view=product-block`);
    const responseText = await response.text();
    const html = await new DOMParser().parseFromString(responseText, "text/html");
    const productCard = html.querySelector(".product-block");
    const container = document.querySelector("#rebuy-top-sellers");

    container.appendChild(productCard);
  });
};

async function main() {
  await renderCards(); // Wait for renderCards() to complete

  const container = document.querySelector("#rebuy-top-sellers");
  const owlInstance = $(container).data("owl.carousel"); // Get the Owl Carousel instance
  // console.log(owlInstance);

  if (owlInstance) {
    owlInstance.destroy(); // Destroy the Owl Carousel
    // console.log("destroyed");
    setTimeout(() => {
      $(container).owlCarousel({
        items: 4,
        nav: true, // Add navigation arrows
        navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'], // Customize navigation arrows if needed
        responsive: {
          0: {
            items: 2,
          },
          768: {
            items: 3,
          },
          992: {
            items: 4,
          },
        },
      });
    }, 2000);
  }
}

main();
